/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
export const HttpErrorCodes = {
  HTTP_ERROR_CODE_400: 400,

  HTTP_ERROR_CODE_401: 401,

  HTTP_ERROR_CODE_403: 403,

  HTTP_ERROR_CODE_404: 404,

  HTTP_ERROR_CODE_405: 405,

  HTTP_ERROR_CODE_407: 407,

  HTTP_ERROR_CODE_408: 408,

  HTTP_ERROR_CODE_409: 409,

  HTTP_ERROR_CODE_410: 410,

  HTTP_ERROR_CODE_415: 415,

  HTTP_ERROR_CODE_422: 422,

  HTTP_ERROR_CODE_429: 429,

  HTTP_ERROR_CODE_500: 500,

  HTTP_ERROR_CODE_501: 501,

  HTTP_ERROR_CODE_502: 502,

  HTTP_ERROR_CODE_503: 503,

  HTTP_ERROR_CODE_504: 504,

  HTTP_REQUEST_ABORTED: 999,
};

export const HttpSuccessCodes = {
  HTTP_SUCCESS_CODE_200: 200,
  HTTP_SUCCESS_CODE_201: 201,
};
